import React, { useState, useContext, useEffect } from "react";
import { Button } from "@mui/material";
import AddBusinessModal from "./addBusinessModal";
import UpgradePlan from "../../../util/upgrade/upgradePlan";
import { UserContext } from "../../auth/auth-context"; 
import { usePermissions } from "../../../hooks/usePermissions";
import { getEffectivePlan } from "../../../util/utils";

const BusinessSettings = () => {
  const { providerUser } = useContext(UserContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkPlanNeeded, setCheckPlanNeeded] = useState(false);

  const standardPlanRequired = 3;

  const [isDiabled, setIsDisabled] = useState(false);

  const { canEditBusiness } = usePermissions();

  useEffect(() => {
    const canEdit = canEditBusiness();
    canEdit ? setIsDisabled(false) : setIsDisabled(true);
  }, []);

  const handleCreateBusiness = () => {
    const effectivePlan = getEffectivePlan(providerUser);

    // Check if user's plan meets the required level
    if (effectivePlan < standardPlanRequired) {
      setCheckPlanNeeded(true);
      // Do not open the AddBusinessModal if upgrade is needed.
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleCreateBusiness}
        disabled={isDiabled}
      >
        Create New Business Profile
      </Button>

      {checkPlanNeeded && (
        <UpgradePlan
          featureName="Create an additional business profile"
          requiredPlanId={standardPlanRequired}
          onClose={() => setCheckPlanNeeded(false)}
        />
      )}

      <AddBusinessModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default BusinessSettings;
